import { z } from 'zod';

export const AdvisorRole = z.enum(['advisor', 'owner', 'manager', 'other']);
export const BusinessStructure = z.enum(['independent', 'hosted', 'employee', 'group', 'franchise', 'other']);
export const AffiliationKind = z.enum(['agency', 'host', 'group', 'franchise', 'consortium']);
export const SalesExperience = z.enum(['not_yet', 'some', 'regular', 'specialist']);
export const CommunicationChannel = z.enum(['email', 'in_app', 'sms', 'push']);
const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .transform((value) => value || null)
    .nullable()
    .default(null);
const years = z.number().int().min(0).max(80).nullable().default(null);

export const AdvisorProfile = z.strictObject({
  country: optionalText(100),
  region: optionalText(100),
  language: optionalText(80),
  communication_channel: CommunicationChannel.nullable().default(null),
  job_title: optionalText(120),
  role: AdvisorRole.nullable().default(null),
  business_structure: BusinessStructure.nullable().default(null),
  years_in_travel: years,
  years_selling_cruise: years,
  years_selling_expedition: years,
  expedition_sales_experience: SalesExperience.nullable().default(null),
  destination_specialties: z.array(z.string().trim().min(1).max(80)).max(20).default([]),
  // ponytail: self-declared names only; link to verified organization records when sponsor segmentation is built.
  affiliations: z
    .array(z.strictObject({ kind: AffiliationKind, name: z.string().trim().min(1).max(160) }))
    .max(10)
    .default([]),
});
export type AdvisorProfile = z.infer<typeof AdvisorProfile>;
export const AdvisorProfileRecord = z.object({
  user_id: z.uuid(),
  revision: z.number().int().positive().nullable(),
  profile: AdvisorProfile,
});
export type AdvisorProfileRecord = z.infer<typeof AdvisorProfileRecord>;
export const AdvisorProfilePut = AdvisorProfileRecord.strict();
